import { Link } from 'react-router-dom';
import React from 'react';
import './AddButton.css';

export const AddButton = ({ ...props }) => {
    return <Link {...props} className="add-button">+</Link>
};


// WEBPACK FOOTER //
// ./src/components/AddButton.js